// Selecting elements
const parentCheckboxes = document.querySelectorAll('.parent-checkbox');
const subCheckboxes = document.querySelectorAll('.sub-checkbox');
const multiSelectionElements = document.querySelectorAll('.multiple-selection');
const subGroups = document.querySelectorAll('[data-sub-parent]');

// Check inputs status and toggle visibility
const checkInputsStatus = (selectedItemsContainer) => {
  multiSelectionElements.forEach((el) => {
    const checkedInputs = el.querySelectorAll('input:checked');
    selectedItemsContainer.classList.toggle('hide', checkedInputs.length === 0);
  });
};

// Add or remove selected items based on checkbox state
const addSelection = (element, selectedItemsContainer) => {
  const inputId = element.getAttribute('id');
  const targetNode = document.querySelectorAll(`[data-input="${inputId}"]`);

  if (element.checked) {
    const parentElem = element.closest('.checkbox');
    const inputText = parentElem?.querySelector('.checkbox__label-text').textContent;

    const htmlString = `
    <div class="multiple-selection__selections-item" data-input="${inputId}">
      <span class="multiple-selection__selections-text">${inputText}</span>
      <button aria-label="remove ${inputText}" class="multiple-selection__selections-close">
        <i class="icon : icon-close : blue : p-none"></i>
      </button>
    </div>
  `;

    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlString.trim();
    selectedItemsContainer.appendChild(tempDiv.firstChild);
  } else {
    targetNode.forEach((item) => {
      item.remove();
    });
  }
  checkInputsStatus(selectedItemsContainer);
};

// Handle parent checkbox change
const handleParentCheckbox = (parentCheckbox) => {
  const parentGroup = parentCheckbox.closest('[data-main-parent]');
  const subCheckboxes = parentGroup.querySelectorAll('.sub-checkbox');
  const mainParent = parentCheckbox.closest('.multiple-selection');
  const selectedItemsContainer = mainParent.querySelector('.multiple-selection__selections');

  if (parentCheckbox.checked) {
    subCheckboxes.forEach((checkbox) => {
      if (!checkbox.checked) {
        checkbox.checked = true;
        const inputId = checkbox.getAttribute('id');
        const existingItem = selectedItemsContainer.querySelector(`[data-input="${inputId}"]`);
        if (!existingItem) {
          addSelection(checkbox, selectedItemsContainer);
        }
      }
    });
  } else {
    subCheckboxes.forEach((checkbox) => {
      if (checkbox.checked) {
        checkbox.checked = false;
        const inputId = checkbox.getAttribute('id');
        const targetNode = selectedItemsContainer.querySelector(`[data-input="${inputId}"]`);
        targetNode?.remove();
      }
    });
  }
  handleSubCheckbox();
};

// Handle sub checkbox change
const handleSubCheckbox = () => {
  parentCheckboxes.forEach((parentCheckbox) => {
    let allChecked = true;
    let noneChecked = true;
    const parentGroup = parentCheckbox.closest('[data-main-parent]');
    const subCheckboxes = parentGroup.querySelectorAll('.sub-checkbox');

    // Determine parent checkbox state based on child checkboxes
    subCheckboxes.forEach((checkbox) => {
      if (checkbox.checked) {
        noneChecked = false;
      } else {
        allChecked = false;
      }
    });

    // Update parent checkbox state
    if (allChecked) {
      parentCheckbox.checked = true;
      parentCheckbox.indeterminate = false;
    } else if (noneChecked) {
      parentCheckbox.checked = false;
      parentCheckbox.indeterminate = false;
    } else {
      parentCheckbox.checked = false;
      parentCheckbox.indeterminate = true;
    }
  });
};

// Event listeners for parent checkboxes
parentCheckboxes.forEach((parentCheckbox) => {
  const mainParent = parentCheckbox.closest('.multiple-selection');
  const selectedItemsContainer = mainParent.querySelector('.multiple-selection__selections');

  parentCheckbox.addEventListener('change', () => {
    handleParentCheckbox(parentCheckbox);
    handleSubCheckbox();
    checkInputsStatus(selectedItemsContainer);
  });
});

// Event listeners for sub checkboxes
subCheckboxes.forEach((checkbox) => {
  checkbox.addEventListener('change', handleSubCheckbox);
});

// Event listeners for adding or removing selected items
multiSelectionElements.forEach((element) => {
  const inputs = element.querySelectorAll('.sub-checkbox');
  const selectedItemsContainer = element.querySelector('.multiple-selection__selections');

  inputs.forEach((input) => {
    input.addEventListener('change', (event) => {
      addSelection(event.target, selectedItemsContainer);
    });
  });
});

// Remove selected item on close click
attachEvent('.multiple-selection__selections-close', 'click', (ev) => {
  const mainParent = ev.target.closest('.multiple-selection');
  const selectedItemsContainer = mainParent.querySelector('.multiple-selection__selections');
  const parent = ev.target.closest('.multiple-selection__selections-item');
  const productId = parent.getAttribute('data-input');
  const targetInput = document.getElementById(productId);
  targetInput.checked = false;

  if (mainParent.classList.contains('is-open')) {
    setTimeout(() => {
      parent.remove();
    }, 10);
  } else {
    parent.remove();
  }

  subGroups.forEach((el) => {
    const subGroupParent = el.closest('[data-main-parent]');
    const checkedInputs = el.querySelectorAll('input:checked');
    const checkedInputsLength = checkedInputs.length;
    const parentCheckbox = subGroupParent.querySelector('.parent-checkbox');
    parentCheckbox.checked = false;
    parentCheckbox.indeterminate = checkedInputsLength !== 0;
  });

  checkInputsStatus(selectedItemsContainer);

  ev.preventDefault();
});

// Open dropdown
attachEvent('.multiple-selection__dropdown-btn', 'click', (ev) => {
  const parent = ev.target.closest('.multiple-selection');
  const dropdown = parent.querySelector('.multiple-selection__body');

  if (!parent.classList.contains('is-open')) {
    parent.classList.add('is-open');
    slideDown(dropdown, 300, 'block');
  }
});

// Close dropdown
document.addEventListener('click', (ev) => {
  const parents = document.querySelectorAll('.multiple-selection');

  parents.forEach((parentsItem) => {
    const dropdown = parentsItem.querySelector('.multiple-selection__body');

    const clickInside = parentsItem.contains(ev.target);
    if (!clickInside) {
      parentsItem.classList.remove('is-open');
      slideUp(dropdown, 300);
    }
  });
});
attachEvent('.multiple-selection__arrow', 'click', (ev) => {
  const parent = ev.target.closest('.multiple-selection');
  const dropdown = parent.querySelector('.multiple-selection__body');

  parent.classList.remove('is-open');
  slideUp(dropdown, 300, 'block');
});
